import styled from "styled-components"
import { colors } from "../../../../lib/colors"
interface cube_props {
  color: string
  shadow: string
  background: string
}

export const CollectWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-height: 450px;
  min-height: 400px;
  align-items: center;
  opacity: 0;
  width: 260px;
  animation: collectAppear 1s linear forwards;
  @keyframes collectAppear {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  @media only screen and (min-width: 350px) {
    width: 280px;
  }
  @media only screen and (min-width: 375px) {
    width: 300px;
  }

  @media only screen and (min-width: 768px) {
    width: 400px;
  }
  @media only screen and (min-width: 1024px) {
    /* padding: 24px; */
  }
`
export const Title = styled.div<{ color: string }>`
  h2 {
    color: ${({ color }) =>
      color === "solar"
        ? colors.solar.title
        : color === "galactical"
        ? colors.galactical.title
        : colors.stellar.title};
    font-size: 34px;
    text-transform: uppercase;
    font-weight: 600;
    padding-top: 8px;
  }
  p {
    font-size: 28px;
    font-weight: 400;
    background: ${({ color }) =>
      color === "solar"
        ? colors.solar.gradient
        : color === "galactical"
        ? colors.galactical.gradient
        : colors.stellar.gradient};
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    text-align: center;
    /* padding-top: 9px; */
    /* text-fill-color: transparent; */
  }
  @media only screen and (min-width: 768px) {
    h2 {
      font-size: 38px;
    }
    p {
      font-size: 32px;
      padding-top: 9px;
      /* padding-top: 15px; */
    }
  }
`

export const Cube = styled.div<cube_props>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 144px;
  height: 122px;
  font-weight: 400;
  font-size: 14px;
  text-transform: uppercase;
  color: ${({ color }) => color};
  box-shadow: ${({ shadow }) => shadow};
  background: ${({ background }) => background};
  border-radius: 14px;
  margin: 40px 0 50px;
  img {
    width: 103px;
    height: 115px;
    margin-top: -46px;
    margin-bottom: 10px;
  }
  @media only screen and (min-width: 768px) {
    width: 164px;
    height: 140px;
    margin: 52px 0 38px;
    /* margin: 62px 0px; */
    img {
      width: 138px;
      height: 152px;
      margin-top: -22px;
    }
  }
`
export const CollectBtn = styled.div<{ color: string }>`
  text-transform: uppercase;
  padding: 14px;
  border-radius: 8px;
  color: #ffffff;
  width: 144px;
  text-align: center;
  font-weight: 400;
  font-size: 24px;
  line-height: 100%;
  cursor: pointer;
  background: ${({ color }) =>
    color === "solar"
      ? colors.solar.gradient
      : color === "galactical"
      ? colors.galactical.gradient
      : colors.stellar.gradient};
  box-shadow: ${({ color }) =>
    color === "solar"
      ? colors.solar.shadow
      : color === "galactical"
      ? colors.galactical.shadow
      : colors.stellar.shadow};
  margin-bottom: 10px;
  @media only screen and (min-width: 768px) {
    font-size: 28px;
    padding: 20px;
    width: 222px;
    margin-bottom: 0px;
  }
`
